module.exports = __webpack_public_path__ + "img/inco5Ac.48209dc5.png";